import React, { useEffect } from 'react'
import { Box, TextField } from '@material-ui/core'
import { Controller, FormContext } from 'react-hook-form'
import { Autocomplete } from '@material-ui/lab'
import { orderBy, isEmpty } from 'lodash'

import { Label, LoadingFeedback, AutocompleteTypeAndSearch } from 'components'

import useFetch from 'hooks/useFetch'

import * as service from 'service'

const LiaForm = ({ control, watch, errors, clearError, setDataProcesses }) => {
  // Objeto form para passar ao FormContext
  const formMethods = {
    control,
    watch,
    errors,
    clearError,
  }

  const { response, isLoading } = useFetch(
    service.dponet.departments.get,
    { perPage: 999 },
    [],
  )

  const departments = response?.data?.departments || []
  const selectedDepartment = watch('departmentId')
  const departmentWasSelected = !!selectedDepartment?.id

  const { response: dataProcessesResponse, isLoading: loadingDataProcess } =
    useFetch(
      service.dponet.dataProcesses.getWithLiaAnswers,
      {
        departmentId: selectedDepartment?.id,
      },
      [selectedDepartment?.id],
      !!selectedDepartment?.id,
    )

  const allDataProcessesDepartment = dataProcessesResponse?.data?.dataProcesses

  const noDataProcessWasFound =
    !loadingDataProcess && isEmpty(allDataProcessesDepartment)

  useEffect(() => {
    if (selectedDepartment?.id) clearError('departmentId')

    if (!!watch('dataProcess')) {
      clearError('dataProcess')
      if (watch('dataProcess').id === 0) {
        setDataProcesses(allDataProcessesDepartment)
      } else {
        setDataProcesses([watch('dataProcess')])
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDepartment?.id, watch('dataProcess')])

  const allDataProcessOption = [
    {
      id: 0,
      name: 'Todos',
    },
  ]

  const dataProcessesOptions = !!allDataProcessesDepartment && [
    ...allDataProcessOption,
    ...allDataProcessesDepartment,
  ]

  return (
    <FormContext {...formMethods}>
      <form>
        <Box display="flex" width="100%" gridGap={6}>
          <LoadingFeedback open={isLoading} />
          {!isLoading && (
            <Box
              display="flex"
              flexDirection="column"
              width={departmentWasSelected ? '60%' : '50%'}
            >
              <Label title="Departamento" titleVariant="subtitle1">
                <AutocompleteTypeAndSearch
                  name="departmentId"
                  minCharsToSearch={2}
                  requestToLoadOptions={async (term) => {
                    if (!term || term.length < 2) return []
                    return departments.filter((d) =>
                      d.name?.toLowerCase().includes(term.toLowerCase()),
                    )
                  }}
                  textField={{
                    label: 'Digite o nome do departamento',
                    variant: 'outlined',
                    error: !!errors.departmentId,
                    helperText: errors?.departmentId?.message,
                  }}
                />
              </Label>
            </Box>
          )}
          {!noDataProcessWasFound && (
            <Box display="flex" flexDirection="column" width="100%">
              <Label title="Processos" titleVariant="subtitle1">
                <Controller
                  control={control}
                  name="dataProcess"
                  onChange={([, data]) => data}
                  mode="onChange"
                  as={
                    <Autocomplete
                      options={orderBy(dataProcessesOptions, 'id') || []}
                      getOptionLabel={(option) => option.name || ''}
                      getOptionSelected={(option, value) =>
                        option.id === value.id
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Digite o nome do processo"
                          variant="outlined"
                          error={!!errors?.dataProcess}
                          helperText={errors?.dataProcess?.message}
                        />
                      )}
                    />
                  }
                />
              </Label>
            </Box>
          )}
          {noDataProcessWasFound && !!selectedDepartment?.id && (
            <Box display="flex" width="100%" alignItems="flex-end">
              <TextField
                label="Nenhum processo encontrado para este departamento"
                disabled
                fullWidth
              />
            </Box>
          )}
        </Box>
      </form>
    </FormContext>
  )
}

export default LiaForm
